import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Download from '@/types/Download';
import DownloadStateEnum from '@/enums/DownloadStateEnum';
import { LinkUtils } from '@/components/commons/Utils';
const linkUtils = new LinkUtils();

/** Gestionnaire de Téléchargement global à l'application */
@Module({
    namespaced: true
})
class DownloadingStore extends VuexModule {
//#region Data
    /** Liste des téléchargements */
    private downloadList: Download[] = [];
    /** Dernier index de la liste des téléchargement */
    private lastIndex: number = -1;
    /** Boolean pour animation de l'icone présent dans le Header de la MasterPage */
    private animation: boolean = false;
//#endregion Data
//#region Mutations
    /** Réinitialisation du store VueX */
    @Mutation
    private reset() {
        this.downloadList = [];
        this.lastIndex = -1;
        this.animation = false;
    }

    /** Méthode pour l'ajout d'un téléchargement
     * @param download
     */
    @Mutation
    private addDownloading(download: Download){
        this.downloadList.push(download);
        this.lastIndex = download.Index;
    }

    /** Ajout du resultat en base64 du fichier au téléchargement
     * @param index Index du téléchargement présent dans la liste Download
     * @param data Resultat en base64 du fichier
     */
    @Mutation
    private addData({index, data}){
        let download: Download = this.downloadList.find(u => u.Index === index);

        if(download){
            download.Data = data;

            if(this.downloadList.length > 5)
                this.downloadList.splice(0, 1);

            if(download.Direct)
            {
                linkUtils.GenerateFile(download.Data, download.Name);
                download.State = DownloadStateEnum.Downloaded;
            }
        }
    }

    /** Mise à jour du status du téléchargement
     * @param index Index du téléchargement présent dans la liste Download
     * @param state Status du téléchargement
     */
    @Mutation
    private updateState({index, state}){
        let download: Download = this.downloadList.find(u => u.Index === index);

        if(download)
            download.State = state;
    }

    /** Mise à jour de l'animation de téléchargement 
     * @param value Boolean pour afficher animation ou non
     */
    @Mutation
    private updateAnimation(value: boolean){
        this.animation = value;
    }

    /**
     * Mise à jour du type du téléchargement
     * @param value String du type de téléchargement
     */
    @Mutation
    private updateType({index, value}){
        let download: Download = this.downloadList.find(u => u.Index === index);

        if(download)
        {
            download.Type = value;

            if(download.Name.includes(value) === false)
            {
                download.Name += value;
            }
        }
    } 

    /**
     * Mise à jour du nom du téléchargement
     * @param value String du type de téléchargement
     */
    @Mutation
    private updateName({index, value}){
        let download: Download = this.downloadList.find(u => u.Index === index);

        if(download)
        {
            console.debug(value);
            download.Name = value;
        }
    }  
//#endregion Mutations
//#region Actions
    /** Réinitialisation du store VueX */
    @Action({ rawError: true })
    public Reset() {
        this.context.commit('reset');
    }

    /** Ajout d'un téléchargement à la liste 
     * @param Download Téléchargement à ajouter a la liste downloadList
     */
    @Action({ rawError: true })
    public AddDownloading(download: Download){
        this.context.commit('addDownloading', download);
    }

    /** Ajout du base64 au téléchargement 
     * @param index Index du téléchargement dans la liste downloadList
     * @param data Base64 du fichier
     */
    @Action({ rawError: true })
    public AddData({index, data}){
        this.context.commit('addData', {index, data});
    }

    /** Mise à jour du status du téléchargement
     * @param index Index du téléchargement
     * @param state Status du téléchargement
     */
    @Action({ rawError: true })
    public UpdateState({index, state}){
        this.context.commit('updateState', {index, state})

        if(state === DownloadStateEnum.Finished){
            this.context.commit('updateAnimation', true);

            setTimeout(() => {
                this.context.commit('updateAnimation', false);
            }, 2500);
        }
    }

    /** Mise à jour du type du téléchargement
     * @param index Index du téléchargement
     * @param state Type du téléchargement
     */
    @Action({ rawError: true })
    public UpdateType({index, value}){
        this.context.commit('updateType', {index, value});
    }

    /** Mise à jour du nom du téléchargement
     * @param index Index du téléchargement
     * @param state Nom du téléchargement
     */
    @Action({ rawError: true })
    public UpdateName({index, value}){
        this.context.commit('updateName', {index, value});
    }
//#endregion Actions
//#region Getters
    /** Getter de la liste downloadList */
    public get GetDownloadList(): Download[] {
        return this.downloadList;
    }

    /** Getter du dernier index de la liste downloadList */
    public get GetLastIndex(): number {
        return this.lastIndex;
    }

    /** Getter du boolean pour l'animation de téléchargement */
    public get GetAnimationState(): boolean {
        return this.animation;
    }
//#endregion Getters
}

export default DownloadingStore;